import { useTranslation } from 'react-i18next';
import classes from './Cards.module.scss';
import icon_01 from '../../../assets/img/MechanicalWorks/Cards/icon_01.svg';
import icon_02 from '../../../assets/img/MechanicalWorks/Cards/icon_02.svg';
import icon_03 from '../../../assets/img/MechanicalWorks/Cards/icon_03.svg';
import icon_04 from '../../../assets/img/MechanicalWorks/Cards/icon_04.svg';

const cards = [
    {
        icon: icon_01,
        text: 'mechanical.cards.text_01',
    },
    {
        icon: icon_02,
        text: 'mechanical.cards.text_02',
    },
    {
        icon: icon_03,
        text: 'mechanical.cards.text_03',
    },
    {
        icon: icon_04,
        text: 'mechanical.cards.text_04',
    },
];

const Cards = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <h2 className={`${classes.title} font-48`}>
                    {t('mechanical.cards.title')}
                </h2>
                <div className={classes.cards}>
                    {cards.map((card, index) =>
                        <div key={index} className={classes.card}>
                            <img className={classes.icon} src={card.icon} alt='' />
                            <p className={`${classes.text} font-16`}>
                                {t(card.text)}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Cards;
